export default {"src":"/_next/static/media/ra-hangar.78c50f21.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};